// ---------------------------
// AUTO-GENERATED. DO NOT EAT.
// ---------------------------

import { createEnum } from "@cartographerio/util";

import { MapCollaborationModel } from "../types.generated";

const CrossWorkspace: MapCollaborationModel = "CrossWorkspace";
const SingleWorkspace: MapCollaborationModel = "SingleWorkspace";

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const MapCollaborationModelEnum = {
  ...createEnum("MapCollaborationModel", [
    [CrossWorkspace, "Cross workspace"],
    [SingleWorkspace, "Single workspace"],
  ]),
  CrossWorkspace,
  SingleWorkspace,
};

export default MapCollaborationModelEnum;
